const ChairishContext = window.chairisher.context;

/**
 * Whether uploading images, as opposed to just PDFs, is allowed.
 *
 * @return {boolean}
 */
export function getShouldAllowImages() {
    return ChairishContext.SHOULD_ALLOW_IMAGES || true;
}

/**
 * The URL to which to upload files.
 *
 * @return {string}
 */
export function getUploadUrl() {
    return ChairishContext.FILE_UPLOAD_URL || '';
}
